import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { DateToLocal } from 'components/dates';
import { FormCanvas } from 'components/form-fields';
import { ShowHide } from 'components/layout';

// A signature pad for a review's sign-off: its heading, the canvas the signature is drawn on, and
// when it was signed once a signature has been drawn.
export function SignatureField(
    {
        id = null,
        headingText = "",
        signature = null,
        signedAt = null,
        loading = false,
        onChange
    }
) {

    return (
        <div id={id} className="form-field">
            <h4 className={classNames({ "bp6-skeleton": loading })}>{headingText}</h4>
            <FormCanvas
                isLoading={loading}
                headingText={null}
                width="40%"
                backgroundColour="#ffffff"
                onChange={onChange}
            />
            <ShowHide
                evaluator={signature != null && signature !== ""}
                show={(
                    <p className="spacer-top-small">Signed <DateToLocal format="DD/MM/YYYY HH:mm">{signedAt}</DateToLocal></p>
                )}
            />
        </div>
    );
}

SignatureField.propTypes = {
    id: PropTypes.string,
    headingText: PropTypes.string,
    signature: PropTypes.string,
    signedAt: PropTypes.instanceOf(Date),
    loading: PropTypes.bool,
    onChange: PropTypes.func.isRequired
};
